import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  Business as BusinessIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';

interface RegistrationCompleteProps {
  organizationName: string;
  adminEmail: string;
}

export const RegistrationComplete: React.FC<RegistrationCompleteProps> = ({
  organizationName,
  adminEmail,
}) => {
  const handleStartUsingApp = () => {
    // メインアプリケーションに遷移
    window.location.href = '/';
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <CheckCircleIcon 
        sx={{ 
          fontSize: 80, 
          color: 'success.main', 
          mb: 2 
        }} 
      />
      
      <Typography variant="h5" gutterBottom color="success.main">
        登録が完了しました！
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 4 }}>
        マンション管理組合の登録が正常に完了し、自動的にログインされました。
      </Typography>

      <Card sx={{ mb: 4, textAlign: 'left' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            登録情報
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText
                primary="マンション名"
                secondary={organizationName}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <EmailIcon />
              </ListItemIcon>
              <ListItemText
                primary="管理者メールアドレス"
                secondary={adminEmail}
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      <Alert severity="info" sx={{ mb: 4, textAlign: 'left' }}>
        <Typography variant="body2">
          <strong>次のステップ:</strong><br />
          • ダッシュボードで基本設定を確認<br />
          • 他のメンバーを招待して組織を拡大<br />
          • 取引データをインポートして家計簿を開始
        </Typography>
      </Alert>

      <Button
        variant="contained"
        size="large"
        startIcon={<DashboardIcon />}
        onClick={handleStartUsingApp}
        sx={{ mt: 2 }}
      >
        ダッシュボードを開始
      </Button>
    </Box>
  );
};